import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=8313c9b8&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=8313c9b8&prod&lang=scss&scoped=true"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=8313c9b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8313c9b8",
  null
  
)

export default component.exports